import { AdminMessage } from "@components/admin/admin-helpers"
import { FileDownload } from "@components/atoms/FileDownload"
import { defineBlock, EditableText } from "eddev/blocks"

export const meta: BlockMeta = {
  title: "File Download",
  icon: "download",
  category: "media",
  description: "Embed a file download, with metadata",
  tags: ["#subpage"],
  flags: {
    contentWidth: true,
    marginRule: "long-card",
  },
}

export default defineBlock("content/file-download", (props) => {
  const file = props.fileDownload!

  if (!file) {
    if (env.admin) {
      return <AdminMessage>No file has been selected</AdminMessage>
    }
  }

  return (
    <div>
      <FileDownload
        date={file?.dateGmt!}
        size={file?.fileSize!}
        target="_blank"
        url={file.mediaItemUrl!}
        title={<EditableText store="label" defaultValue={file.title} />}
        data-mixpanel-block="File Download"
      />
    </div>
  )
})
